export default __webpack_public_path__ + "static/media/arrow-right.7041d082.svg";